// extracted by mini-css-extract-plugin
module.exports = {"formItem":"FormItem_formItem__3aiGa","field":"FormItem_field__1nKsg","label":"FormItem_label__1u0RB","cube":"FormItem_cube__1hjaa","error":"FormItem_error__1sKYV"};